"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const AdminOnly_1 = require("../../../comps/reusables/AdminOnly");
const CreateResourcesButton_1 = require("../../../comps/reusables/CreateResourcesButton");
const react_2 = require("@osmosys/react");
const svg_1 = require("../../../svg");
const graphql_1 = require("../../../graphql");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const NewContextButton_1 = require("./NewContextButton");
const AdsManagerFeatureFlagToggle_1 = require("../AdsManagerNew/AdsManagerFeatureFlagToggle");
const inputs_1 = require("../../../inputs");
const react_router_dom_1 = require("react-router-dom");
exports.AdsList = () => {
    const router = use_react_router_1.default();
    const history = react_router_dom_1.useHistory();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysListLayout, { pathToCount: "adsCount", pathToItems: "ads", pathToName: "name", itemName: "ad", itemsName: "ads", showReloadButton: true, query: {
                query: graphql_1.ads,
            }, toolbarRight: () => {
                return (react_1.default.createElement("div", { className: "d-flex justify-content-end" },
                    react_1.default.createElement(AdminOnly_1.AdminOnly, { workspaceAdminsAlso: true },
                        react_1.default.createElement(AdsManagerFeatureFlagToggle_1.AdsManagerFeatureFlagToggle, null)),
                    react_1.default.createElement("div", { className: "col-md-8" },
                        react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "ad", label: false, onChange: (ad) => {
                                history.push(`/ads/${ad.id}`);
                            } }))));
            }, toolbarLeft: () => {
                return (react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(CreateResourcesButton_1.CreateResourcesButton, { label: "New ad", modalProps: {
                            fields: (react_1.default.createElement(reusables_1.FormGroup, { name: "html", label: "HTML code", type: "textarea" })),
                            formProps: {
                                formikProps: {
                                    initialValues: {
                                        html: '',
                                        name: '',
                                    },
                                },
                                mutationProps: {
                                    mutation: graphql_1.createAd,
                                    onCompleted: addAdResult => {
                                        router.history.push(`/ads/${addAdResult.createAd.id}`);
                                    },
                                },
                                valuesToVariables: values => {
                                    return {
                                        data: {
                                            html: values.html,
                                            name: values.name,
                                        },
                                    };
                                },
                            },
                            header: 'New ad',
                        } }),
                    ' ',
                    react_1.default.createElement(AdminOnly_1.AdminOnly, null,
                        react_1.default.createElement(NewContextButton_1.NewContextButton, null))));
            }, itemProps: item => {
                return {
                    body: react_1.default.createElement(react_1.default.Fragment, null, item.html ? 'Has HTML' : 'No HTML'),
                    createdAt: item.createdAt,
                    icon: (react_1.default.createElement(react_2.OsmosysTooltip, { label: `Ad #${item.id}` },
                        react_1.default.createElement(svg_1.AdsManagerLogo, { width: "64", height: "64" }))),
                    linkURL: `/ads/${item.id}`,
                    title: item.name,
                };
            } })));
};
exports.default = exports.AdsList;
//# sourceMappingURL=index.js.map